import { toast } from 'sonner';
import { CheckCircle, XCircle, Info, AlertTriangle } from 'lucide-react';

// Toasts personalizados con auto-cierre rápido y fluido (2.5s)
export const showToast = {
  success: (message, options = {}) => {
    return toast.success(message, {
      duration: 3000,
      dismissible: true,
      closeButton: true,
      style: {
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '16px',
        padding: '14px 18px',
        boxShadow: '0 8px 24px rgba(16, 185, 129, 0.3)',
        fontSize: '14px',
        fontWeight: '600',
      },
      icon: <CheckCircle className="w-5 h-5 shrink-0" />,
      ...options,
    });
  },

  error: (message, options = {}) => {
    return toast.error(message, {
      duration: 3500,
      dismissible: true,
      closeButton: true,
      style: {
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '16px',
        padding: '14px 18px',
        boxShadow: '0 8px 24px rgba(239, 68, 68, 0.3)',
        fontSize: '14px',
        fontWeight: '600',
      },
      icon: <XCircle className="w-5 h-5 shrink-0" />,
      ...options,
    });
  },

  info: (message, options = {}) => {
    return toast.info(message, {
      duration: 2500,
      dismissible: true,
      closeButton: true,
      style: {
        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '16px',
        padding: '14px 18px',
        boxShadow: '0 8px 24px rgba(59, 130, 246, 0.3)',
        fontSize: '14px',
        fontWeight: '600',
      },
      icon: <Info className="w-5 h-5 shrink-0" />,
      ...options,
    });
  },

  warning: (message, options = {}) => {
    return toast.warning(message, {
      duration: 3000,
      dismissible: true,
      closeButton: true,
      style: {
        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '16px',
        padding: '14px 18px',
        boxShadow: '0 8px 24px rgba(245, 158, 11, 0.3)',
        fontSize: '14px',
        fontWeight: '600',
      },
      icon: <AlertTriangle className="w-5 h-5 shrink-0" />,
      ...options,
    });
  },
};
